import { createAction, props } from '@ngrx/store';

export const setDsToken = createAction('[Auth] Set DS Token', props<{ dsToken: string | null }>());
export const setAccessToken = createAction('[Auth] Set Access Token', props<{ accessToken: string | null }>());
export const setRefreshToken = createAction('[Auth] Set Refresh Token', props<{ refreshToken: string | null }>());
export const setReloginUrl = createAction('[Auth] Set Relogin Url', props<{ reloginUrl: string | null }>());

export const logout = createAction('[Auth] Logout (Clear Tokens)');
